import { controls } from "../../controls";

const rp1013 = {
  label: "MOU ASSET REGISTER",
  pageLabel: "MOU ASSET REGISTER",
  starting: true,
  url: "rp1013",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    
    ...controls.displayText({tab: "filter",label: "April Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"april_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "May Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"May_date",width:"col-sm-2"}),    
    
    ...controls.displayText({tab: "filter",label: "June Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"june_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "July Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"july_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "August Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"august_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "September Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"September_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "October Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"october_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "November Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"november_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "December Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"december_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "January Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"january_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "February Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"february_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "March Date",width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"march_date",width:"col-sm-2"}),    
    
  ],
  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "MOU REGISTER Asset",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
        {
            Header: "DATE",
            accessor: "trdate",
            type:"date"
          },      
          {
            Header: "Balance",
            columns: [
              {
                Header: "CASH ON HAND",
                accessor: "cash_on_hand",
                type:"currency"
              },
              {
                Header: "MSC OD",
                accessor: "msc_od",
                type:"currency"
              },
              {
                accessor: "cash_with_bank",
                Header: "CASH WITH BANK",
                type:"currency"
              }          
            ]
          },
          {
            Header: "Investments",
            columns: [
              {
                Header: "S.L.R.",
                accessor: "slr",
                type:"currency"
              },
              {
                Header: "NON S.L.R.",
                accessor: "non_slr",
                type:"currency"
              },
              {
                accessor: "total_investments",
                Header: "TOTAL",
                type:"currency"
              }
            ]
          },
          {
            Header: "Loans Outstanding",
            columns: [
              {
                Header: "S.T.SAO",
                accessor: "stsao",
                type:"currency"
              },
              {
                Header: "S.T.Other",
                accessor: "st_other",
                type:"currency"
              },
              {
                Header: "CASH CREDIT",
                accessor: "cash_credit",
                type:"currency"
              },
              {
                Header: "M.T.AGRI.",
                accessor: "mtagri",
                type:"currency"
              },
              {
                Header: "M.T.NON-AGRI.",
                accessor: "mt_nonagri",
                type:"currency"
              },
              {
                Header: "M.T.CONV.",
                accessor: "mt_conv",
                type:"currency"
              },
              {
                Header: "L.T.AGRI.",
                accessor: "ltagri",
                type:"currency"
              },
              {
                Header: "L.T.NON AGRI.",
                accessor: "lt_nonagri",
                type:"currency"
              },
              {
                Header: "STY IN LIQUIDATION",
                accessor: "sty_in_liquidation",
                type:"currency"
              },
              {
                Header: "AGRI.RELIEF GOVT.",
                accessor: "agri_relief_govt",
                type:"currency"
              },
              {
                accessor: "total_of_loan_outstanding",
                Header: "TOTAL OF LOAN OUTSTANDING",
                type:"currency"
              }
            ]
          },
          {
            Header: "Non earning Assets",
            columns: [
              {
                Header: "LAND & BUILDING",
                accessor: "land_and_building",
                type:"currency"
              },
              {
                Header: "FURNITURE & DEAD STOCK",
                accessor: "furniture_and_deadstock",
                type:"currency"
              },
              {
                Header: "VEHICLE & LIABRARY",
                accessor: "vehicle_and_library",
                type:"currency"
              },
              {
                accessor: "total_non_earning_assets",
                Header: "TOTAL",
                type:"currency"
              }
            ]
          },
          {
            Header: "Other Assets",
            columns: [
              {
                Header: "INT.RECEIVABLE",
                accessor: "int_receivable",
                type:"currency"
              },
              {
                Header: "BR.ADJUSTMENT",
                accessor: "branch_adjustment",
                type:"currency"
              },
              {
                Header: "ARDR",
                accessor: "ar_dr",
                type:"currency"
              },
              {
                Header: "OTHER IF ANY",
                accessor: "other_if_any",
                type:"currency"
              },
              {
                Header: "SUNDRY",
                accessor: "sundry",
                type:"currency"
              },
              {
                accessor: "total_other_assets",
                Header: "TOTAL",
                type:"currency"
              }
            ]
          },
          {
            Header: "INCOME (def)",
            accessor: "incomedef",            
            type:"currency"
          },
          {
            Header: "EXPENSE (def)",
            accessor: "expensedef",            
            type:"currency"
          },
          {
            Header: "DEFICIT EXCESS OF INCOME",        
            accessor: "defecitexcessic",
            type:"currency"
          },
          {
            Header: "Accumulated LOSSES",
            accessor: "accumulated_losses",
            type:"currency"
          },
          {
            accessor: "grand_total_working_fund",
            Header: "GRAND TOTAL WORKING FUND",
            type:"currency"
          },
          
          {
            Header: "CONTRA",
            accessor: "contra",
            type:"currency"
          },
          {
            Header: "TOTAL AS PER BALANCE SHEET",
            accessor: "grand_final",
            type:"currency"
          }
               
    ]
  }
};

export default rp1013;